/* eslint-disable */
import { memo, useMemo } from "react";
import { FormikProps, getIn } from "formik";
import {
  findKeysByValue,
  loanPageHelperText
} from "../../../../helpers/FormDetails/ProposalDetails/resources";
import CustomTextField from "../../../../shared/CustomTextField";
import CustomCheckBox from "../../../../shared/CustomCheckBox";
import AddMoreButton from "src/shared/AddMoreButton";
import Button from "@mui/material/Button";
import Resources from "src/config/Resources";
import CustomSelect from "src/shared/CustomSelect";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import { Tooltip } from "@mui/material";
import { handelIndianCurrencyChange, onChangeIndianCurrency } from "src/helpers/FormDetails";

interface Props {
  formik: FormikProps<any>;
  existingLifeCoverLength: number;
  handleExistingLifeCoverAddButton: () => void;
  handleExistingLifeCoverRemoveButton: (index: number) => void;
}
function ExtraDetails({
  formik: { errors, handleBlur, touched, values, handleChange, setFieldValue, setFieldTouched },
  existingLifeCoverLength,
  handleExistingLifeCoverAddButton,
  handleExistingLifeCoverRemoveButton
}: Props) {
  const insuranceCompanyOptions = useAppSelector(
    (state) => state.masterdata_reducer.insuranceCompanyDetails
  );
  const policyStatusOptions = useAppSelector(
    (state) => state.masterdata_reducer.policyStatusDetails
  );

  const partnerId = useAppSelector((state) => state?.common?.leadDetails?.partnerId);
  const handleInsuranceCompanyChange = (event: any, existingCoverIndex: number) => {
    setFieldValue(event.target.name, event.target.value);
    setFieldValue(
      `existingPolicy.existingPolicyDetails[${existingCoverIndex}].nameOfInsuranceCompanyCode`,
      findKeysByValue(insuranceCompanyOptions, event.target.value)
    );
  };

  const handleAcceptanceTermsChange = (event: any, existingCoverIndex: number) => {
    setFieldValue(event.target.name, event.target.value);
    setFieldValue(
      `existingPolicy.existingPolicyDetails[${existingCoverIndex}].acceptanceTermsCode`,
      findKeysByValue(policyStatusOptions, event.target.value)
    );
  };

  const getHeadingLabel = useMemo(
    () => loanPageHelperText?.existingLifeCover(partnerId),
    [partnerId]
  );

  return (
    <div className="text-left space-y-6">
      <div>
        <CustomCheckBox
          label={getHeadingLabel}
          name="existingPolicy.existingLifeCover"
          handleBlur={handleBlur}
          setFieldValue={setFieldValue}
          checked={values?.existingPolicy?.existingLifeCover}
        />
      </div>
      {values.existingPolicy?.existingLifeCover &&
        Array(existingLifeCoverLength)
          .fill(1)
          .map((_, existingCoverIndex) => (
            <div className="space-y-2">
              {existingCoverIndex > 0 && (
                <div className="flex justify-end">
                  <Button
                    variant="outlined"
                    onClick={() => handleExistingLifeCoverRemoveButton(existingCoverIndex)}
                    classes={{ root: "!px-0" }}
                    className="!text-black !uppercase h-10 !rounded-lg !border-2"
                  >
                    <img src={Resources.images.FormDetails.removeIcon} alt="remove" />
                  </Button>
                </div>
              )}
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-10 gap-y-6">
                <CustomTextField
                  requiredStar
                  label="Policy/ Application No."
                  onChange={handleChange}
                  handleBlur={handleBlur}
                  value={
                    values?.existingPolicy?.existingPolicyDetails[existingCoverIndex]?.policyNumber
                  }
                  name={`existingPolicy.existingPolicyDetails[${existingCoverIndex}].policyNumber`}
                  error={getIn(
                    errors,
                    `existingPolicy.existingPolicyDetails[${existingCoverIndex}].policyNumber`
                  )}
                  touched={getIn(
                    touched,
                    `existingPolicy.existingPolicyDetails[${existingCoverIndex}].policyNumber`
                  )}
                />
                <CustomTextField
                  requiredStar
                  label="Total Sum Assured (in Rs)"
                  onChange={(event) => handelIndianCurrencyChange(event, { setFieldValue })}
                  handleBlur={handleBlur}
                  value={onChangeIndianCurrency(
                    values?.existingPolicy?.existingPolicyDetails[existingCoverIndex]
                      ?.totalSumInsured
                  )}
                  name={`existingPolicy.existingPolicyDetails[${existingCoverIndex}].totalSumInsured`}
                  error={getIn(
                    errors,
                    `existingPolicy.existingPolicyDetails[${existingCoverIndex}].totalSumInsured`
                  )}
                  touched={getIn(
                    touched,
                    `existingPolicy.existingPolicyDetails[${existingCoverIndex}].totalSumInsured`
                  )}
                />
                <Tooltip
                  title="Name Of Insurance Company*"
                  placement="top"
                  classes={{ tooltipPlacementTop: "!m-0.5" }}
                  PopperProps={{
                    className: "!z-0"
                  }}
                >
                  <div>
                    <CustomSelect
                      requiredStar
                      label="Name Of Insurance Company"
                      options={Object.values(insuranceCompanyOptions)}
                      onChange={(event) => handleInsuranceCompanyChange(event, existingCoverIndex)}
                      setFieldTouched={setFieldTouched}
                      value={
                        values?.existingPolicy?.existingPolicyDetails[existingCoverIndex]
                          ?.nameOfInsuranceCompany
                      }
                      name={`existingPolicy.existingPolicyDetails[${existingCoverIndex}].nameOfInsuranceCompany`}
                      error={getIn(
                        errors,
                        `existingPolicy.existingPolicyDetails[${existingCoverIndex}].nameOfInsuranceCompany`
                      )}
                      touched={getIn(
                        touched,
                        `existingPolicy.existingPolicyDetails[${existingCoverIndex}].nameOfInsuranceCompany`
                      )}
                    />
                  </div>
                </Tooltip>
                <CustomSelect
                  requiredStar
                  label="Acceptance Terms"
                  options={Object.values(policyStatusOptions)}
                  onChange={(event) => handleAcceptanceTermsChange(event, existingCoverIndex)}
                  setFieldTouched={setFieldTouched}
                  value={
                    values?.existingPolicy?.existingPolicyDetails[existingCoverIndex]
                      ?.acceptanceTerms
                  }
                  name={`existingPolicy.existingPolicyDetails[${existingCoverIndex}].acceptanceTerms`}
                  error={getIn(
                    errors,
                    `existingPolicy.existingPolicyDetails[${existingCoverIndex}].acceptanceTerms`
                  )}
                  touched={getIn(
                    touched,
                    `existingPolicy.existingPolicyDetails[${existingCoverIndex}].acceptanceTerms`
                  )}
                />
              </div>
            </div>
          ))}
      {values.existingPolicy?.existingLifeCover && (
        <div>
          <p className="font-montserrat text-xs leading-4 md:text-sm font-medium">
            {loanPageHelperText.info}
          </p>
        </div>
      )}
      {values.existingPolicy?.existingLifeCover && existingLifeCoverLength < 3 && (
        <div className="mt-6">
          <AddMoreButton
            label="Add More Policy Details(Max. 3)"
            onClick={handleExistingLifeCoverAddButton}
          />
        </div>
      )}
    </div>
  );
}

export default memo(ExtraDetails);
